module.exports = __webpack_public_path__ + "static/media/3d-inventory-system.f700b25d.jpg";